import styled from 'styled-components';
import { mediaQueryDesktopMin } from 'styleUtils';
var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-j1sxxt-0"
})(["display:inline-flex;justify-content:center;align-items:center;margin-left:5.3px;position:relative;width:13.33px;&:after{content:'';position:absolute;top:-16px;bottom:-16px;left:-16px;right:-16px;z-index:1;}svg{width:13.33px;height:13.33px;}@media ", "{&:after{top:-8px;bottom:-8px;left:-8px;right:-8px;}}"], mediaQueryDesktopMin);
export default Wrapper;